import { Component } from '@angular/core';

import { RefreshOverlayService } from './refresh-overlay.service';

@Component({
  selector: 'refresh-overlay',
  styleUrls: ['./refresh-overlay.component.scss'],
  templateUrl: './refresh-overlay.component.html',
})
export class RefreshOverlayComponent {
  constructor(public refreshOverlayService: RefreshOverlayService) { }

  public onOverlayClick(): void {
    this.refreshOverlayService.isFullScreenOverlayVisible = false;
    this.refreshOverlayService.refresh$.next();
  }
}
